import type { AuthResponse, SignupRequest, LoginRequest, User } from "@vms/tubeforge-shared";
import { apiPost, apiGet, apiRequest } from "./client.ts";

export const authApi = {
  signup: (body: SignupRequest) => apiPost<AuthResponse>("/auth/signup", body),
  login: (body: LoginRequest) => apiPost<AuthResponse>("/auth/login", body),
  me: () => apiGet<{ user: User }>("/auth/me"),
  refresh: () => apiPost<AuthResponse>("/auth/refresh"),
  verifyEmail: (email: string, code: string) => apiPost<{ ok: boolean }>("/auth/verify-email", { email, code }),
  resendVerification: () => apiPost<{ ok: boolean }>("/auth/resend-verification"),
  sendOtp: (email: string) => apiPost<{ ok: boolean }>("/auth/otp/send", { email }),
  verifyOtp: (email: string, code: string) => apiPost<AuthResponse>("/auth/otp/verify", { email, code }),
  // (audit 10-20) the route requires the password: it was never sent, so every delete was a 400
  deleteAccount: (password: string) => apiRequest<{ ok: boolean }>("/auth/account", { method: "DELETE", body: { password } }),
};
